var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000064",
    strokeWidth: 1.5,
    d: "M.53 1.47l18.75 18.75M.72 20.22L19.47 1.47"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxsaW5lIHgxPSIwLjUzMDMzIiB5MT0iMS40Njk2NyIgeDI9IjE5LjI4MDMiIHkyPSIyMC4yMTk3IiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+DQo8bGluZSB4MT0iMC43MTk2NyIgeTE9IjIwLjIxOTciIHgyPSIxOS40Njk3IiB5Mj0iMS40Njk2NyIgc3Ryb2tlPSIjMDAwMDY0IiBzdHJva2Utd2lkdGg9IjEuNSIvPg0KPC9zdmc+DQo=";
export { SvgIconClose as ReactComponent };